import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { DocSubmissionRepository } from '@/store/doc-submission-state/doc-submission-state.repository';

interface IgetDocSubmissionUpdateDrawerObjectProps {
  store?: DocSubmissionRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getDocSubmissionUpdateDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: IgetDocSubmissionUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.docSubmission.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.docSubmission.update.update',
        onClick: () => action?.(),
        disabled: store?.getObservable<boolean>('isEqual'),
      },
      {
        label: 'settings.docSubmission.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
